import * as omitBy from 'lodash/omitBy';
export class ObjectUtil {

	public static cleanup(object: any, clearNull: boolean = false, clearUndefined: boolean = true) {
		return omitBy(object, value => clearNull && value === null || clearUndefined && value === undefined);
	}

	public static keys(object: any, isEnum: boolean = true): string[] {
		const keys: Array<string> = Object.keys(object);
		return isEnum ? keys.slice(keys.length / 2) : Object.values(object);
	}

	public static extend(target: any, source: any, options?: any): any {
		const array = Array.isArray(source);

		if (array) {
			// Not sure why this is needed. Cant find usages
			return Array.isArray(target) ? ObjectUtil.defaultArrayMerge(target, source) : ObjectUtil.cloneIfNecessary(source, options);
		} else {
			return ObjectUtil.mergeObject(target, source, options);
		}
	}

	private static isMergeableObject(obj: any): boolean {
		return obj && typeof obj === 'object' && Object.prototype.toString.call(obj) !== '[object RegExp]' && Object.prototype.toString.call(obj) !== '[object Date]';
	}

	private static emptyTarget(val: any): any {
		return Array.isArray(val) ? [] : {};
	}

	private static cloneIfNecessary(obj: any, options?: any): any {
		const clone = options && options.clone;
		return clone && this.isMergeableObject(obj) ? ObjectUtil.extend(this.emptyTarget(obj), obj, options) : obj;
	}

	private static defaultArrayMerge(target: Array<any>, source: Array<any>): Array<any> {
		return source.slice();
	}

	private static mergeObject(target: any, source: any, options?: any): any {
		const destination = {};

		if (this.isMergeableObject(target)) {
			Object.keys(target).forEach(function (key): void {
				destination[key] = ObjectUtil.cloneIfNecessary(target[key], options);
			});
		}
		Object.keys(source).forEach(function (key): void {
			if (!ObjectUtil.isMergeableObject(source[key]) || !target[key]) {
				destination[key] = ObjectUtil.cloneIfNecessary(source[key], options);
			} else {
				destination[key] = ObjectUtil.extend(target[key], source[key], options);
			}
		});
		return destination;
	}

	/**
	 * Convert an array to object with its value being `value`
	 */
	public static arrayToObject(array: any[], value: any): Object {
		return array?.reduce((acc, qp) => {
			acc[qp] = value;
			return acc;
		}, {}) ?? {};
	}
}
